import styled from 'styled-components';

export const Container = styled.div`
  .MuiTypography-root {
    margin-top: 10px;
  }
`;
